import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import PageTitle from 'components/common/page-title';
import AssessmentList from 'components/assessments/assessment-list';
import { getAssessments } from 'actions/assessments';

import './styles.css';

class Assessments extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getAssessments());
  }

  render() {
    const { assessments } = this.props;

    return (
      <Grid>
        <Row>
          <Col lg={12}>
            <PageTitle>Assessments</PageTitle>
          </Col>
        </Row>
        <AssessmentList assessments={assessments} />
      </Grid>
    );
  }
}

const mapStateToProps = (state) => (
  { assessments: state.assessments.assessments }
);

export default connect(mapStateToProps)(Assessments);



// WEBPACK FOOTER //
// ./src/components/assessments/index.jsx